import { motion, useReducedMotion } from "motion/react";
import { cn } from "@eduviaos/ui-kit";
import { useLearnLocale } from "../../../lib/i18n/useLearnLocale";

/**
 * Indeterminate progress bar for a background roadmap generation.
 *
 * The AI call has no server-side progress signal, so this is deliberately
 * indeterminate rather than a fake percentage. Only `transform` animates,
 * and the sweep is dropped under `prefers-reduced-motion`.
 */
export function RoadmapBuildingBar({
  className,
  tone = "onDark",
}: {
  className?: string;
  /** `onDark` sits on the celebrate hero; `onCard` on a plain surface. */
  tone?: "onDark" | "onCard";
}) {
  const reduce = useReducedMotion();
  const { strings } = useLearnLocale();
  const onDark = tone === "onDark";

  return (
    <div
      role="progressbar"
      aria-busy="true"
      aria-valuetext={strings.roadmapBuildingTitle}
      className={cn(
        "relative h-2 w-full overflow-hidden rounded-full",
        onDark ? "bg-white/20" : "bg-muted",
        className,
      )}
    >
      {reduce ? (
        <div className={cn("h-full w-1/3 rounded-full", onDark ? "bg-white/80" : "bg-primary")} />
      ) : (
        <motion.div
          className={cn("h-full w-1/3 rounded-full", onDark ? "bg-white/80" : "bg-primary")}
          initial={{ x: "-100%" }}
          animate={{ x: "300%" }}
          transition={{ duration: 1.4, ease: "linear", repeat: Infinity }}
        />
      )}
    </div>
  );
}
